import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

class Ip {
  async bulk(items, enrichments, timeoutMs) {
    const body = { ip: items };
    if (Array.isArray(enrichments) && enrichments.length > 0) {
      body.enrichments = enrichments;
    }
    const config = {};
    if (typeof timeoutMs === 'number') config.timeout = timeoutMs;
    let { data } = await axios.post(API_URL + '/query/ip/bulk', body, config);
    return data;
  }

  async Get(ip, enrichments) {
    const config = {};
    // Gin binds `form:"enrichments"` from repeated `enrichments=` keys (not the
    // bracketed array form), so serialize the list that way.
    if (Array.isArray(enrichments) && enrichments.length > 0) {
      config.params = { enrichments };
      config.paramsSerializer = p => p.enrichments.map(e => `enrichments=${encodeURIComponent(e)}`).join('&');
    }
    let { data } = await axios.get(API_URL + '/query/ip/' + ip, config);
    return data;
  }

  async EventRange(ip, start, end) {
    let { data } = await axios.post(API_URL + '/query/event/range', {
      ip: ip, 
      start: start,
      end: end
    });

    data = data.data;

    data = data.map( (elem) => {
      let tmp = { timestamp: elem.timestamp }
      Object.assign(tmp, elem.data)
      return tmp
    })

    return data;
  }

  async Events(ip, start, end) {
    let { data } = await axios.post(API_URL + '/query/event/highlights', {
      ip: ip, 
      start: start,
      end: end
    });
    return data;
  }

  async EventIps(start, end) {
    let { data } = await axios.post(API_URL + '/query/event/ips', {
      start: start,
      end: end
    });
    return data;
  }

  async EventTopTalkers(start, end) {
    let { data } = await axios.post(API_URL + '/query/event/stats/toptalkers', {
      start: start,
      end: end
    });
    return data;
  }


  async EventStats(start, end) {
    let { data } = await axios.post(API_URL + '/query/event/stats', {
      start: start,
      end: end
    });
    return data;
  }

  async EventStatsIp(start, end) {
    let { data } = await axios.post(API_URL + '/query/event/stats/ip', {
      start: start,
      end: end
    });
    return data;
  }

  async EventStatsCountry(start, end) {
    let { data } = await axios.post(API_URL + '/query/event/stats/country', {
      start: start,
      end: end
    });
    return data;
  }

  async IpAnonymizationProviders(ip) {
    let { data } = await axios.get(API_URL + '/query/ip/' + ip + '/anonymization_providers');
    return data;
  }

  async getSchema() {
    let { data } = await axios.get(API_URL + '/query/schema/ip');
    return data;
  }

}

export default new Ip();
